import { cn } from '../../lib/utils';

export const EmptyState = ({ icon: Icon, title, description, action, className }) => {
  return (
    <div className={cn('empty-state', className)}>
      {Icon && (
        <div className="mb-4 flex justify-center">
          <div className="w-16 h-16 rounded-full bg-slate-100 flex items-center justify-center">
            <Icon size={32} className="text-slate-400" />
          </div>
        </div>
      )}
      <h3 className="font-secondary font-semibold text-lg text-slate-700 mb-2">
        {title}
      </h3>
      {description && (
        <p className="text-slate-500 mb-6 max-w-md mx-auto">
          {description}
        </p>
      )}
      {action}
    </div>
  );
};

export default EmptyState;
